/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import { CustomField } from "api/custom-field";

enum Actions {
  LOAD_CUSTOM_FIELDS = "@@custom-fields/LIST_CUSTOM_FIELDS",
  LOAD_CUSTOM_FIELDS_SUCCESS = "@@custom-fields/LIST_CUSTOM_FIELDS_SUCCESS",
  LOAD_CUSTOM_FIELDS_FAILURE = "@@custom-fields/LIST_CUSTOM_FIELDS_FAILURE",

  SAVE_CUSTOM_FIELD = "@@custom-fields/SAVE_CUSTOM_FIELD",
  SAVE_CUSTOM_FIELD_SUCCESS = "@@custom-fields/SAVE_CUSTOM_FIELD_SUCCESS",
  SAVE_CUSTOM_FIELD_FAILURE = "@@custom-fields/SAVE_CUSTOM_FIELD_FAILURE",

  DELETE_CUSTOM_FIELD = "@@custom-fields/DELETE_CUSTOM_FIELD",
  DELETE_CUSTOM_FIELD_SUCCESS = "@@custom-fields/DELETE_CUSTOM_FIELD_SUCCESS",
  DELETE_CUSTOM_FIELD_FAILURE = "@@custom-fields/DELETE_CUSTOM_FIELD_FAILURE"
}

export type LOAD_CUSTOM_FIELDS_ACTION = { type: Actions.LOAD_CUSTOM_FIELDS };
export type LOAD_CUSTOM_FIELDS_SUCCESS_ACTION = {
  type: Actions.LOAD_CUSTOM_FIELDS_SUCCESS;
  payload: { customFields: Array<CustomField> };
};
export type LOAD_CUSTOM_FIELDS_FAILURE_ACTION = {
  type: Actions.LOAD_CUSTOM_FIELDS_FAILURE;
  payload: { error: Error };
};

export type SAVE_CUSTOM_FIELD_ACTION = { type: Actions.SAVE_CUSTOM_FIELD };
export type SAVE_CUSTOM_FIELD_SUCCESS_ACTION = { type: Actions.SAVE_CUSTOM_FIELD_SUCCESS };
export type SAVE_CUSTOM_FIELD_FAILURE_ACTION = { type: Actions.SAVE_CUSTOM_FIELD_FAILURE; payload: { error: Error } };

export type DELETE_CUSTOM_FIELD_ACTION = { type: Actions.DELETE_CUSTOM_FIELD; payload: { customField: CustomField } };
export type DELETE_CUSTOM_FIELD_SUCCESS_ACTION = { type: Actions.DELETE_CUSTOM_FIELD_SUCCESS };
export type DELETE_CUSTOM_FIELD_FAILURE_ACTION = {
  type: Actions.DELETE_CUSTOM_FIELD_FAILURE;
  payload: { error: Error };
};

export type ActionTypes =
  | LOAD_CUSTOM_FIELDS_ACTION
  | LOAD_CUSTOM_FIELDS_SUCCESS_ACTION
  | LOAD_CUSTOM_FIELDS_FAILURE_ACTION
  | SAVE_CUSTOM_FIELD_ACTION
  | SAVE_CUSTOM_FIELD_SUCCESS_ACTION
  | SAVE_CUSTOM_FIELD_FAILURE_ACTION
  | DELETE_CUSTOM_FIELD_ACTION
  | DELETE_CUSTOM_FIELD_SUCCESS_ACTION
  | DELETE_CUSTOM_FIELD_FAILURE_ACTION;

export default Actions;
